import React from 'react';
import { Modal, Button, ConfigProvider } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';

interface DeleteUserModalProps {
  open: boolean;
  userName: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  open,
  userName,
  loading = false,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal open={open} onCancel={onCancel} footer={null} closable={false} width={400} centered>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#24252C',
          },
        }}
      >
        <div className="flex gap-3 items-start">
          <CloseCircleFilled className="text-red-500 text-2xl flex-shrink-0" />
          <div className="flex flex-col flex-1">
            <p className="font-semibold text-base leading-6 text-gray-900 mb-2">
              Are you sure you want to delete this user?
            </p>
            <p className="text-sm leading-[22px] text-gray-900">
              <span className="font-semibold">{userName}</span> will be removed from this
              organization and lose access immediately.
            </p>
            <div className="flex justify-end gap-2 mt-3">
              <Button
                type="primary"
                onClick={onCancel}
                disabled={loading}
                className="!bg-[#24252C] !border-[#24252C] !text-white hover:!bg-[#3a3b44]"
              >
                Cancel
              </Button>
              <Button
                onClick={onConfirm}
                loading={loading}
                disabled={loading}
                className="!bg-white !text-red-500 !border-red-500 hover:!bg-red-50"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </ConfigProvider>
    </Modal>
  );
};

export default DeleteUserModal;
